const data = [
  { tz: 'Europe/Amsterdam', countryCodes: ['NL'] },
  { tz: 'Europe/Andorra', countryCodes: ['AD'] },
  { tz: 'Europe/Astrakhan', countryCodes: ['RU'] },
  { tz: 'Europe/Athens', countryCodes: ['GR'] },
  { tz: 'Europe/Belfast', countryCodes: ['GB'] },
  { tz: 'Europe/Belgrade', countryCodes: ['RS','BA','HR','ME','MK','SI'] },
  { tz: 'Europe/Berlin', countryCodes: ['DE'] },
  { tz: 'Europe/Bratislava', countryCodes: ['SK'] },
  { tz: 'Europe/Brussels', countryCodes: ['BE'] },
  { tz: 'Europe/Bucharest', countryCodes: ['RO'] },
  { tz: 'Europe/Budapest', countryCodes: ['HU'] },
  { tz: 'Europe/Busingen', countryCodes: ['DE'] },
  { tz: 'Europe/Chisinau', countryCodes: ['MD'] },
  { tz: 'Europe/Copenhagen', countryCodes: ['DK'] },
  { tz: 'Europe/Dublin', countryCodes: ['IE'] },
  { tz: 'Europe/Gibraltar', countryCodes: ['GI'] },
  { tz: 'Europe/Guernsey', countryCodes: ['GG'] },
  { tz: 'Europe/Helsinki', countryCodes: ['FI','AX'] },
  { tz: 'Europe/Isle_of_Man', countryCodes: ['IM'] },
  { tz: 'Europe/Istanbul', countryCodes: ['TR'] },
  { tz: 'Europe/Jersey', countryCodes: ['JE'] },
  { tz: 'Europe/Kaliningrad', countryCodes: ['RU'] },
  { tz: 'Europe/Kiev', countryCodes: ['UA'] },
  { tz: 'Europe/Kirov', countryCodes: ['RU'] },
  { tz: 'Europe/Lisbon', countryCodes: ['PT'] },
  { tz: 'Europe/Ljubljana', countryCodes: ['SI'] },
  { tz: 'Europe/London', countryCodes: ['GB','GG','IM','JE'] },
  { tz: 'Europe/Luxembourg', countryCodes: ['LU'] },
  { tz: 'Europe/Madrid', countryCodes: ['ES'] },
  { tz: 'Europe/Malta', countryCodes: ['MT'] },
  { tz: 'Europe/Mariehamn', countryCodes: ['AX'] },
  { tz: 'Europe/Minsk', countryCodes: ['BY'] },
  { tz: 'Europe/Monaco', countryCodes: ['MC'] },
  { tz: 'Europe/Moscow', countryCodes: ['RU'] },
  { tz: 'Europe/Nicosia', countryCodes: ['CY'] },
  { tz: 'Europe/Oslo', countryCodes: ['NO','SJ'] },
  { tz: 'Europe/Paris', countryCodes: ['FR'] },
  { tz: 'Europe/Podgorica', countryCodes: ['ME'] },
  { tz: 'Europe/Prague', countryCodes: ['CZ','SK'] },
  { tz: 'Europe/Riga', countryCodes: ['LV'] },
  { tz: 'Europe/Rome', countryCodes: ['IT','SM','VA'] },
  { tz: 'Europe/Samara', countryCodes: ['RU'] },
  { tz: 'Europe/San_Marino', countryCodes: ['SM'] },
  { tz: 'Europe/Sarajevo', countryCodes: ['BA'] },
  { tz: 'Europe/Saratov', countryCodes: ['RU'] },
  { tz: 'Europe/Simferopol', countryCodes: ['RU','UA'] },
  { tz: 'Europe/Skopje', countryCodes: ['MK'] },
  { tz: 'Europe/Sofia', countryCodes: ['BG'] },
  { tz: 'Europe/Stockholm', countryCodes: ['SE'] },
  { tz: 'Europe/Tallinn', countryCodes: ['EE'] },
  { tz: 'Europe/Tirane', countryCodes: ['AL'] },
  { tz: 'Europe/Tiraspol', countryCodes: ['MD'] },
  { tz: 'Europe/Ulyanovsk', countryCodes: ['RU'] },
  { tz: 'Europe/Uzhgorod', countryCodes: ['UA'] },
  { tz: 'Europe/Vaduz', countryCodes: ['LI'] },
  { tz: 'Europe/Vatican', countryCodes: ['VA'] },
  { tz: 'Europe/Vienna', countryCodes: ['AT'] },
  { tz: 'Europe/Vilnius', countryCodes: ['LT'] },
  { tz: 'Europe/Volgograd', countryCodes: ['RU'] },
  { tz: 'Europe/Warsaw', countryCodes: ['PL'] },
  { tz: 'Europe/Zagreb', countryCodes: ['HR'] },
  { tz: 'Europe/Zaporozhye', countryCodes: ['UA'] },
  { tz: 'Europe/Zurich', countryCodes: ['CH','DE','LI'] }
];
export { data };
